import { Injectable, InjectionToken, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { RestResourceService } from './rest-resource.service';
import { RestFrameworkService } from './rest-framework.service';
import { RestInterpolatorService } from './rest-interpolator.service';
import { RestJsonCodecService } from './rest-json-codec.service';
import type { RestConfiguration, RestResourceConfiguration, RestResourceDescriptor } from './rest.contract';

export type {
  RestConfiguration,
  RestParameterDescriptor,
  RestResourceConfiguration,
  RestResourceDescriptor
} from './rest.contract';

export const REST_CONFIGURATION = new InjectionToken<RestConfiguration>('restConfiguration');

@Injectable({
  providedIn: 'root'
})
export class RestService {
  protected readonly httpClient = inject<HttpClient>(HttpClient);
  protected readonly restFrameworkService = inject<RestFrameworkService>(RestFrameworkService);
  protected readonly restInterpolatorService = inject<RestInterpolatorService>(RestInterpolatorService);
  protected readonly restJsonCodecService = inject<RestJsonCodecService>(RestJsonCodecService);

  private readonly baseUrl: string;
  private readonly resourceConfiguration: RestResourceConfiguration;

  constructor() {
    const configuration = inject<RestConfiguration>(REST_CONFIGURATION);

    this.baseUrl = configuration.baseUrl;
    this.resourceConfiguration = configuration.resourceConfiguration as RestResourceConfiguration;
  }

  getResource(resourceId: string): RestResourceService {
    return new RestResourceService(
      this.httpClient,
      this.restFrameworkService,
      this.restInterpolatorService,
      this.restJsonCodecService,
      {
        id: resourceId,
        baseUrl: this.baseUrl,
        descriptor: this.getResourceDescriptor(resourceId)
      }
    );
  }

  protected getResourceDescriptor(resourceId: string): RestResourceDescriptor {
    let value = resourceId.split('.')
      .reduce((resourceValue: unknown, part: string): unknown => resourceValue && resourceValue[part], this.resourceConfiguration);
    if (value === undefined) {
      value = this.resourceConfiguration[resourceId];
    }
    return value as RestResourceDescriptor;
  }

}
